// extracted by mini-css-extract-plugin
export default {"mainWrap":"Layout_mainWrap__YIEf+","version":"Layout_version__ECfJP"};